<template>
<div>

<div  @keydown.tab.exact.prevent="handleTabPress($event)" class="modal" id="editRowCartModal"  data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content border-primary">
      <div class="modal-header bg-primary">
        <h5 class="modal-title text-white" id="staticBackdropLabel">
          <i style="color:yellow"  class="fas fa-edit mr-3" aria-hidden="true"></i>
          MODIFICA RIGA PRODOTTO </h5>
      </div>
      <div class="border border-warning bg-warning">
        <h4><span  style="color:black" class="mb-1 ml-2"><strong>{{props.title}}</strong></span></h4>  
      </div>
      
      <form v-on:submit.prevent="submit()">
      <div class="modal-body">
        
        <div class="media">
        <div v-if="err">
          <img src="@/assets/no_img.jpg" alt="" class="align-self-center mr-3" width="200" height="200" style="border:1px solid black">
        </div>
        <div v-else>
          <img :src="props.img" @error="err=true"   alt="" width="200" height="200" style="border:1px solid green" class="align-self-center mr-3">                      
        </div>
        <div class="media-body ml-3">
          <div class="form-group ">
            <label for="inputPrListino"><strong>Importo</strong></label>
            <div class="input-group ">
              <div class="input-group-prepend cost_price" data-toggle="tooltip" :title="params.cost_price">
                <div class="input-group-text border border-info">€</div>
              </div>
              <input tabindex="-1" required :disabled="params.disabled" ref="input1" autocomplete="off"  step="0.01" type="number" class="form-control" id="inputPrice" aria-describedby="inputHelp" v-model="params.price">
            </div>
            <small id="inputHelp" class="form-text text-muted"></small>
          </div>
          <div class="form-group ">
            <label for="inputSconto"><strong>Sconto</strong></label>
            <div class="input-group ">
              <div class="input-group-prepend">
                <div class="input-group-text border border-info">%</div>
              </div>
              <input required :disabled="params.disabled" autocomplete="off" type="number" class="form-control" id="inputSconto" v-model="params.discount">
            </div>
          </div>
          <div class="form-group ">
            <label for="shopAss"><strong>Codice Shop Assistant</strong></label>
              <div class="input-group">
                <div class="input-group-prepend">
                <div class="input-group-text  border border-info">#</div>
              </div>
              <input required autocomplete="off" type="number" class="form-control" id="inputSconto" v-model="params.assistant_code">
              </div>
          </div>
          <div class="form-check ">
            <input @click="setDisabled()" type="checkbox" class="form-check-input " id="checkReturn" v-model="params.type">
            <label class="form-check-label " for="checkReturn"><strong>Reso da cliente</strong></label>
          </div>
        </div>
      </div>
      </div>

      <div class="modal-footer">
        <button  @click="closeModal()" type="button" class="btn btn-secondary border border-warning" data-dismiss="modal">CHIUDI</button>
        <button  type="submit" class="btn btn-primary" >APPLICA
            <i style="color:yellow" class="fas fa-check-circle ml-3" aria-hidden="true"></i>
        </button>      
      </div>

</form>  

</div>
</div>
</div>
</div>
</template>
<script>

export default {
  props: ['props'],
  data () {
    return {
      img        : '',
      err        : false,
      params :
      {
        price    : 0,
        discount : 0,
        type     : false,
        disabled : false
      }
    
    }
  },

   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  created: function()
  {
    this.$nextTick(()  => {   

        $('#editRowCartModal').modal('show')
        this.$refs.input1.focus()
        
    
    })  
  },  
  mounted()
    {
            
      this.params.price           = this.props.price
      this.params.discount        = this.props.discount
      this.params.type            = this.props.type
      this.params.assistant_code  = this.props.assistant_code
      this.params.cost_price      = this.props.cost_price
      if(this.props.edit          == 1 && this.props.type == false)
      {        
        this.params.disabled = true
      }
      else
      {
        this.params.disabled = false
      }
            
    },
  methods: 
    {
    closeModal()
    {
      $('#editRowCartModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    },    
    submit()
    {
      $('#editRowCartModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('update',this.params)              
      })    
      
    },  
    setDisabled()
    {      
      if(this.props.edit == 1)
      {
        if(this.params.type == false)
        {
          this.params.disabled = false  
        }
        else
        {
          this.params.price   = this.props.price
          this.params.discount   =  this.props.discount
          this.params.disabled = true
        }
      }
    },
    handleTabPress()
    {
      return false
    }

    }
  
}
</script>
<style scoped>

.form-check-label {
  cursor: pointer;
}


.modal-footer {  
  justify-content: space-between;  
}
.cost_price
{
  cursor: pointer;
}

.form-check-input 
    {
      
      cursor : pointer; 
    }

    
</style>

